import { i18n } from "@lingui/core";
import { msg } from "@lingui/macro";
import { OpenAI } from "openai";

import { useOpenAiStore } from "@/client/stores/openai";

export const openai = async () => {
  const { apiKey, baseURL, useSystemKey } = useOpenAiStore.getState();

  // If using system key, make requests through our backend API
  if (useSystemKey) {
    // Return a proxy object that mimics OpenAI client but routes requests through our API
    return {
      chat: {
        completions: {
          create: async (params: any) => {
            // Replace this with actual API calls when needed
            throw new Error(
              i18n._(msg`This operation requires a direct OpenAI client. Please use one of the specific AI functions instead.`),
            );
          },
        },
      },
    };
  }

  // If using personal key, use the OpenAI client directly
  if (!apiKey) {
    throw new Error(
      i18n._(msg`AI services are temporarily unavailable. Please try again later or contact support.`),
    );
  }

  if (baseURL) {
    return new OpenAI({
      apiKey,
      baseURL,
      dangerouslyAllowBrowser: true,
    });
  }

  return new OpenAI({
    apiKey,
    dangerouslyAllowBrowser: true,
  });
};
